'use client'
import NotFoundLayout from '@/components/layouts/NotFoundLayout'

export default function Error() {
  return <NotFoundLayout />
}
